import Vue from "vue";
import Vuex from "vuex";
import login from "./modules/login";
import api from "./modules/api";
import { createLogger } from "vuex";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    login: login,
    api: api,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
